import { useMutation, gql } from '@apollo/react-hooks';
import { updateModel } from '#/graphql/mutations';
import type { Model, UpdateModelMutation } from '#/graphql/types';
import { get, pick } from 'lodash';
import { useCallback } from 'react';
import { updateMutationFields } from '../utils/mutationDataFields';
import { GET_MODEL } from './useModelQuery';

const q = gql(updateModel);

const useModelUpdate = () => {
  const [mutation, result] = useMutation<UpdateModelMutation>(q);
  const updateModel = useCallback(
    async (itemId: string, model: Model) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(model, updateMutationFields),
        },
        refetchQueries: [{ query: GET_MODEL, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateModel', undefined);
    },
    [mutation],
  );

  return { updateModel, result };
};

export default useModelUpdate;
